export default __webpack_public_path__ + "static/media/fmicro.24a2f0ba.png";